<template>
  <div class="details">
    <div class="breadcrumbDiv">
      <breadcrumb :bread="bread" @handleBreadClick="handleBreadClick"/>
    </div>
    <orderDetails :detailsData="detailsData" :loading="loading" :key="partInfoKey" @getDetail="getDetail" :partner="2"/>
  </div>
</template>
<script>
import orderDetails from "@/components/zhenyunOrder/orderDetails"
import zhenyunOrderMinxis from "@/mixins/zhenyunOrder.js";
import breadcrumb from "@/components/common/zhenyun/breadcrumb"
import {presentUrl} from "@/utils/config.js"
export default {
  mixins: [zhenyunOrderMinxis],
  components:{
    orderDetails,breadcrumb
  },  
  data() {
    return {
      bread:[
        {title:'订单雷达',url:{
          name:"order-radar"
        },class:'breadFirst',id:'1'},
        // {title:'',url:'',class:'breadFirst',id:'1'},
        {title:'',url:'',class:'breadLast',id:'2'}
      ],
      detailsData:null,
      loading:false,
      partInfoKey:new Date().getTime()
    };
  },
  watch:{ 
    detailsData:{
      handler(newVal,oldVal){
        this.bread=[
          {title:'订单雷达',url:{name:"order-radar"},class:'breadFirst',id:'1'},
          {title:'',url:'',class:'breadLast',id:'2'}
        ]
        if(this.$route.query.quoteId){
          this.bread.splice(1,0,{title:'报价编号 '+ this.$route.query.quoteId,url:{
            name:'quote-detail',
            params:{
              id:this.$route.query.quoteId,
            }
          },class:'breadFirst',id:'1'})
          this.bread[2].title='询盘编号 '+ newVal?.id
        }else{
          this.bread[1].title='询盘编号 '+ newVal?.id
        }
      }
    }
  },
  mounted() {
    
  },
  methods:{
    getDetail(val){
      this.detailsData=null
      this.getRfqDetail(val);
      this.partInfoKey=+new Date().getTime()
    },
    handleBreadClick(){
      this.$router.push({
        name: 'quote-detail',
        params: {
          id: this.$route.query.quoteId,
        },
      })
    }
  },
  created(){
    this.getDetail(this.$route.params.id)
  }
};
</script>
<style lang="scss" scoped>
.details{
   font-family: 'SourceHanSansCN-Regular';
   padding: 0 120px;
}
.breadcrumbDiv{
  padding: 16px 0 16px 0px;
}
</style>